import React, { useEffect, useCallback, useState} from 'react';
import WaveformSelector from './WaveformSelector.js';
import {connect} from 'react-redux';

const OscillatorWaveform = ({
    oscillatorType,
    oscillator,
    oscWaveforms,
    setOscWaveforms,
    sampleDragging
}) => { 
    let showing = oscWaveforms === oscillator;
    let className = "oscillator-waveform  ";
    if (showing) {
        className += " showing";
    } else {
        className += " pushable";
    }

    const onDrop = useCallback((e) => {
        e.stopPropagation();
        oscillator.setOscillatorSample(sampleDragging);
    }, [sampleDragging]);

    const toggleWaveform = useCallback((e) => {
        e.stopPropagation();
        console.log('toggle wave');
        setOscWaveforms(showing ? undefined : oscillator);
    }, [showing, oscillator]);

    if (oscillatorType === "sine") {
        oscillatorType = <img src="/sine-icon.svg" className="osc-type-icon sine"/>;
    } else if (oscillatorType === "triangle") {
        oscillatorType = <img src="/triangle-icon.svg" className="osc-type-icon triangle"/>;
    } else if (oscillatorType === "sawtooth") {
        oscillatorType = <img src="/sawtooth-icon.svg" className="osc-type-icon sawtooth"/>;
    } else if (oscillatorType === "square") {
        oscillatorType = <img src="/square-icon.svg" className="osc-type-icon square"/>;
    } else if (oscillatorType === "pulse") {
        oscillatorType = <img src="/pulse-icon.svg" className="osc-type-icon pulse"/>;
    }
    return (
        <div
          onDrop={onDrop}
          onMouseDown={toggleWaveform} className={className}>
          <div className="waveform-type">{oscillatorType}</div>
          {showing ? <WaveformSelector hide={() => setOscWaveforms(undefined)} oscillator={oscillator}/> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      sampleDragging: state.selector.sampleDragging,
      oscillatorType: 
          props.oscillator.customOscillatorType ||
          props.oscillator.oscillatorType
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OscillatorWaveform);
